import React from "react";
import banner4 from "../../assets/banner/banner4.png";
import banner5 from "../../assets/banner/banner5.png";
import { Link } from "react-router-dom";

const ProductBanner = ({ topBanners }) => {
  // Check if topBanners exists and has items
  if (!topBanners || topBanners.length === 0) {
    return null; // Return nothing if no banners available
  }

  return (
    <div className="w-full h-auto mx-auto px-4 ">
      {topBanners.map((banner, index) => (
        <div
          key={banner.top_ban_id || index}
          className="w-full overflow-hidden rounded-lg shadow-lg"
        >
          <Link to={banner.link || "#"}>
            <div className="aspect-[16/9]">
              <img
                loading="lazy"
                src={banner.file_path}
                alt={`Top Banner ${index + 1}`}
                className="size-full object-cover transition-transform duration-500"
              />
            </div>
          </Link>
        </div>
      ))}
    </div>
  );
};

export default ProductBanner;

// const ProductBanner = (props) => {
//   return (
//     <section className="section-4-product-section">
//       <div className="">
//         <div className="grid grid-cols-1 lg:grid-cols-2 gap-0">
//           {/* Product 1 */}
//           <div className="bg-green-600 px-5 flex justify-center items-end">
//             <div className="">
//               <img loading='lazy'
//                 src={banner4}
//                 alt="product img"
//                 className="img-fluid section-4-product1-img max-w-full max-h-full"
//               />
//             </div>
//           </div>

//           {/* Product 2 */}
//           <div className="col-span-1">
//             <div className="relative overflow-hidden">
//               <div className="">
//                 <img loading='lazy'
//                   src={banner5}
//                   alt="Product img"
//                   className="section-4-product2-img w-full h-auto"
//                 />
//                 <div className="section-4-product2-content absolute bottom-1/2 left-1/2 transform -translate-x-1/4 translate-y-1/2 xl:translate-y-1/4 z-10 text-black p-5 text-center">
//                   <h1 className="text-uppercase text-2xl md:text-4xl font-bold">New Summer <br /> Collection</h1>
//                   <a href="#" className="btn btn-dark text-white px-4 py-2 mt-4 inline-block">
//                     Shop Now
//                   </a>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </section>
//   );
// };

// export default ProductBanner;
